/**
 * EMMERA — Curseur custom
 * Cercle vert sauge qui grossit au survol des éléments interactifs.
 * Désactivé sur touch devices.
 */
(function () {
  'use strict';

  // Ne pas activer sur touch devices
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.body.style.cursor = 'auto';
    return;
  }

  const cursor = document.getElementById('emmera-cursor');
  const dot    = document.getElementById('emmera-cursor-dot');

  if (!cursor || !dot) return;

  let mouseX = -100, mouseY = -100;
  let cursorX = -100, cursorY = -100;
  let isVisible = false;
  let rafId;

  const INTERACTIVES = 'a, button, [role="button"], input, select, textarea, label, .product-card-wrapper, .emmera-phase-card, .emmera-video-wrapper, [data-cursor-large]';

  // Position dot (suit exactement la souris)
  document.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;

    dot.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;

    if (!isVisible) {
      isVisible = true;
      cursor.style.opacity = '1';
      dot.style.opacity = '1';
    }
  }, { passive: true });

  // Curseur principal — lerp pour un mouvement fluide
  function animateCursor() {
    const dx = mouseX - cursorX;
    const dy = mouseY - cursorY;

    cursorX += dx * 0.12;
    cursorY += dy * 0.12;

    cursor.style.transform = `translate(${cursorX}px, ${cursorY}px) translate(-50%, -50%)`;

    rafId = requestAnimationFrame(animateCursor);
  }

  animateCursor();

  // Entrée/sortie de la fenêtre
  document.addEventListener('mouseleave', () => {
    cursor.style.opacity = '0';
    dot.style.opacity = '0';
    isVisible = false;
  });

  document.addEventListener('mouseenter', () => {
    cursor.style.opacity = '1';
    dot.style.opacity = '1';
    isVisible = true;
  });

  // Grossit sur les éléments interactifs
  function onMouseOver(e) {
    if (e.target.closest(INTERACTIVES)) {
      cursor.classList.add('emmera-cursor--large');
    }
  }

  function onMouseOut(e) {
    if (e.target.closest(INTERACTIVES)) {
      cursor.classList.remove('emmera-cursor--large');
    }
  }

  document.addEventListener('mouseover', onMouseOver);
  document.addEventListener('mouseout', onMouseOut);

  // Restaurer le curseur natif si nécessaire
  window.addEventListener('beforeunload', () => {
    cancelAnimationFrame(rafId);
  });
})();
